import React from 'react';

import { observer } from 'mobx-react';
import { ChannelSort } from 'stream-chat';
import {
  Chat,
  ChannelList,
  Channel,
  ChannelHeader,
  MessageInput,
  MessageList,
  Thread,
  Window,
  LoadingIndicator,
} from 'stream-chat-react';
import { EmojiPicker } from 'stream-chat-react/emojis';
import 'stream-chat-react/dist/css/v2/index.css';

import './LbChat.scss';
import { chatStore } from '../../../stores/chatStore';
import { RefreshButton } from '../RefreshButton/RefreshButton';

const LbChat = observer(() => {
  const { user, chatClient, activeChannelId } = chatStore;

  if (!chatClient || !user) {
    return <LoadingIndicator />;
  }

  const filters = { type: 'messaging', members: { $in: [user.id] } };
  const sort: ChannelSort = { last_message_at: -1 };

  return (
    <div className="str-chat_content_box">
      <Chat client={chatClient} theme="messaging str-chat__theme-lb">
        <ChannelList
          filters={filters}
          sort={sort}
          customActiveChannel={activeChannelId}
        />
        <Channel EmojiPicker={EmojiPicker}>
          <Window>
            <ChannelHeader />
            <MessageList />
            <MessageInput />
          </Window>
          <Thread />
        </Channel>
      </Chat>
      <RefreshButton className="refresh-button" />
    </div>
  );
});

export { LbChat };
